// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"75d8057e","246":"9c2a905b","355":"2fc8b83e","381":"384ca1e0","436":"563473ba","465":"8f47e66b","473":"705599af","502":"1b7515c9","557":"7447f597","866":"affc7181","880":"7d53113a","954":"22d604d8"}[chunkId] + ".chunk.js";
};